import Vue from "vue";
import { format } from "d3";
import { capitalize } from "@/utils/helpers";

Vue.filter("number", (val, round = 2) => {
  if (isNaN(val) || val === null) return "-";

  return format(`,.${round}f`)(val);
});

Vue.filter("capitalize", (val) => {
  return capitalize(val);
});
